import { createSvgIcon } from "@mui/material";

export const XYRulersIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <rect x="2" y="2" width="4" height="16" />
        <rect x="6" y="4.5" width="2.5" height="1" />
        <rect x="6" y="7" width="1.5" height="1" />
        <rect x="6" y="9.5" width="2.5" height="1" />
        <rect x="6" y="12" width="1.5" height="1" />
        <rect x="6" y="14.5" width="2.5" height="1" />
        <rect x="2" y="18" width="20" height="4" />
        <rect x="7.5" y="15" width="1" height="3" />
        <rect x="10.5" y="16.5" width="1" height="1.5" />
        <rect x="13.5" y="15" width="1" height="3" />
        <rect x="16.5" y="16.5" width="1" height="1.5" />
        <rect x="19.5" y="15" width="1" height="3" />
    </svg>,
    "XYRulers"
);
